import * as React from "react";
import { forwardRef } from "react";
const SvgLockOpen = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", className: "lucide lucide-lock-open-icon lucide-lock-open", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { width: 18, height: 11, x: 3, y: 11, rx: 2, ry: 2 }), /* @__PURE__ */ React.createElement("path", { d: "M7 11V7a5 5 0 0 1 9.9-1" }));
const ForwardRef = forwardRef(SvgLockOpen);
export default ForwardRef;
